import { Type } from '@angular/core';
import { isNotBlank } from '@app/utils/string';
import { DateUtils } from '../../date';
import { FormMappingModel } from '../models/form-mapping-model';

export type ArrayMergeFilterFunction<T extends FormMappingModel> = (value: T) => boolean;
export type MergeFunction<T> = (model: T, value: any, attribute: string) => void;

export function ArrayMergeFunction<T extends FormMappingModel>(
  FormModel: Type<T>,
  filterFunction: ArrayMergeFilterFunction<T> = () => true
): (obj: any, value: T[], attribute: string, form: T) => void {
  return (obj, value, attribute, form) => {
    obj[attribute] = (value || [])
      .filter(filterFunction)
      .map((value, index) => FormModel.prototype.merge(obj[attribute][index], value, attribute));

    // if (filterFunction !== undefined) {
    //   obj[attribute] = obj[attribute].filter(filterFunction)
    // }
  };
}

export function BooleanMergeFunction(obj: any, value: any, attribute: string) {
  obj[attribute] = !!value;
}

export const DateMergeFunction = (o, value, attr) => {
  o[attr] = DateUtils.backend(value);
};

export function DefaultMergeFunction<T extends FormMappingModel>(
  FormModel: Type<T>
): (obj: any, value: T, attribute: string) => void {
  return (obj: any, value: T, attribute: string) => {
    obj[attribute] = FormModel.prototype.merge(obj, value, attribute);
  };
}

export function DefaultValueMergeFunction<T extends object, U>(defaultValue: U): MergeFunction<T> {
  return (model: T, value: U, attribute: string) => {
    if (attribute in model === false || model[attribute] == null) {
      model[attribute] = defaultValue;
    }
  };
}

export function IntMergeFunction<T>(model: T, value: string, attribute: string) {
  const parsed = parseInt(value, 10);

  if (Number.isNaN(parsed)) {
    model[attribute] = undefined;
  } else {
    model[attribute] = parsed;
  }
}

export const IsoTimeMergeFunction = (o, value, attr) => {
  o[attr] = DateUtils.toIso(value);
};
export const LocalMergeFunction = () => {};

export const NotBlankMergeFunction = (model: Record<string, any>, value: string, attribute: string) => {
  if (isNotBlank(value)) {
    model[attribute] = value;
  } else {
    model[attribute] = null;
  }
};

export function TimeNormalise(value) {
  if (value && value.length === 4 && value.indexOf(':') === -1) {
    value = value.substring(0, 2) + ':' + value.substring(2, 4);
  }

  return value;
}
